<template>
  <header class="header">
    <div class="table-actions-wrap">
      <div class="left-aligned-wrap">
        <woot-sidemenu-icon />
        <h1 class="page-title header-title">
          {{ headerTitle }}
        </h1>
      </div>


    </div>
    <woot-button
      @click="$emit('open-add-modal')" 
      color-scheme="success" 
      class-names="button--fixed-top mt-50 bg-primary" 
      icon="add-circle"
    >
      {{ buttonText }}
    </woot-button>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import adminMixin from 'dashboard/mixins/isAdmin';

export default {
  mixins: [adminMixin],
  components: {
  },
  props: {
    headerTitle: {
      type: String,
      default: '',
    },
    meta: {
      type: Object,
      default: () => ({}),
    },
    buttonText: {
      type: String,
      default: '',
    },
  },
  data(){
    return {
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'getCurrentUser',
      accountId: 'getCurrentAccountId',
    }),

  },
  methods: {
  },

  watch: {
  },
}
</script>

<style lang="scss" scoped>


.table-actions-wrap {
  display: flex;
  gap: 3rem;
  width: 100%;
  min-height: 55px;
  padding: var(--space-small) var(--space-normal) var(--space-small)
    var(--space-normal);
}

.page-title {
  margin: 0;
}

.left-aligned-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;
  min-width: var(--space-mega);

  .header-title {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin: 0 var(--space-small);
  }
}
</style>
